// Configuración para datos fake del dashboard de solicitudes
export const fakeDataConfig = {
  // Configuración de rangos para KPIs
  kpiRanges: {
    total: { min: 800, max: 1300 },
    pendiente_resolucion: { min: 200, max: 350 },
    resueltas: { min: 600, max: 1000 },
    tasa_crecimiento: { min: -5, max: 15 },
    escaladas: { min: 80, max: 130 },
    reasignadas: { min: 50, max: 80 },
    nuevas: { min: 300, max: 500 },
    en_proceso: { min: 150, max: 250 },
    pendientes: { min: 400, max: 700 },
    tiempo_promedio: { min: 4, max: 12 },
    eficiencia: { min: 75, max: 95 },
    satisfaccion: { min: 3.5, max: 5.0 }
  },

  // Configuración de rangos para métricas SLA
  slaRanges: {
    cumplimiento_general: { min: 80, max: 95 },
    solicitudes_vencidas: { min: 50, max: 80 },
    solicitudes_proximas_vencer: { min: 30, max: 50 },
    sla_criticos: { min: 25, max: 40 },
    tiempo_resolucion_promedio: { min: 8, max: 14 },
    tiempo_asignacion_promedio: { min: 1, max: 3 },
    tiempo_escalacion_promedio: { min: 6, max: 10 },
    cumplimiento_alta: { min: 70, max: 90 },
    cumplimiento_media: { min: 80, max: 95 },
    cumplimiento_baja: { min: 85, max: 95 }
  },

  // Configuración de agentes
  agentes: [
    { nombre: 'María González', performance: { min: 80, max: 130 }, tiempo: { min: 4, max: 7 }, satisfaccion: { min: 4.0, max: 5.0 } },
    { nombre: 'Carlos Rodríguez', performance: { min: 75, max: 120 }, tiempo: { min: 5, max: 8 }, satisfaccion: { min: 3.8, max: 4.8 } },
    { nombre: 'Ana Silva', performance: { min: 70, max: 110 }, tiempo: { min: 4.5, max: 7.5 }, satisfaccion: { min: 4.2, max: 5.0 } },
    { nombre: 'Luis Pérez', performance: { min: 65, max: 100 }, tiempo: { min: 5.5, max: 8.5 }, satisfaccion: { min: 3.9, max: 4.9 } },
    { nombre: 'Carmen Ruiz', performance: { min: 60, max: 95 }, tiempo: { min: 4, max: 6 }, satisfaccion: { min: 4.1, max: 5.0 } },
    { nombre: 'Roberto Torres', performance: { min: 55, max: 90 }, tiempo: { min: 5, max: 7 }, satisfaccion: { min: 3.7, max: 4.7 } }
  ],

  // Configuración de tipos de solicitudes
  tiposSolicitud: [
    { tipo: 'Consulta General', porcentaje: 35, min: 300, max: 500 },
    { tipo: 'Solicitud de Servicio', porcentaje: 25, min: 200, max: 350 },
    { tipo: 'Reporte de Problema', porcentaje: 20, min: 150, max: 250 },
    { tipo: 'Solicitud de Información', porcentaje: 15, min: 100, max: 200 },
    { tipo: 'Otros', porcentaje: 5, min: 80, max: 130 }
  ],

  // Configuración de temas
  temas: [
    { tema: 'Atención al Usuario', porcentaje: 40, min: 350, max: 550 },
    { tema: 'Problemas Técnicos', porcentaje: 25, min: 200, max: 300 },
    { tema: 'Solicitudes de Acceso', porcentaje: 20, min: 150, max: 250 },
    { tema: 'Reportes y Consultas', porcentaje: 15, min: 100, max: 200 }
  ],

  // Configuración de canales
  canales: [
    { canal: 'Portal Web', porcentaje: 45, min: 400, max: 600 },
    { canal: 'Correo Electrónico', porcentaje: 30, min: 250, max: 400 },
    { canal: 'Teléfono', porcentaje: 15, min: 150, max: 250 },
    { canal: 'Chat en Vivo', porcentaje: 10, min: 100, max: 180 }
  ],

  // Configuración de prioridades
  prioridades: [
    { prioridad: 'Alta', porcentaje: 20, min: 100, max: 150 },
    { prioridad: 'Media', porcentaje: 50, min: 200, max: 300 },
    { prioridad: 'Baja', porcentaje: 30, min: 150, max: 250 }
  ],

  // Configuración de estados del workflow
  estadosWorkflow: [
    { estado: 'Nueva', porcentaje: 25, min: 150, max: 250 },
    { estado: 'Asignada', porcentaje: 20, min: 120, max: 200 },
    { estado: 'En Proceso', porcentaje: 30, min: 180, max: 280 },
    { estado: 'Pendiente', porcentaje: 15, min: 100, max: 160 },
    { estado: 'Resuelta', porcentaje: 10, min: 300, max: 500 }
  ],

  // Configuración de distribución de satisfacción
  distribucionSatisfaccion: [
    { puntuacion: 5, porcentaje: 45, min: 300, max: 500 },
    { puntuacion: 4, porcentaje: 35, min: 200, max: 350 },
    { puntuacion: 3, porcentaje: 15, min: 80, max: 130 },
    { puntuacion: 2, porcentaje: 3, min: 30, max: 50 },
    { puntuacion: 1, porcentaje: 2, min: 20, max: 40 }
  ],

  // Configuración de métricas de negocio
  metricasNegocio: {
    costo_por_solicitud: { min: 30, max: 50 },
    roi_servicio: { min: 25, max: 40 },
    satisfaccion_cliente: { min: 85, max: 95 },
    tiempo_resolucion_objetivo: { min: 4, max: 8 }
  },

  // Configuración de carga de trabajo
  cargaTrabajo: {
    total_agentes: 8,
    agente_activo: { min: 5, max: 7 },
    solicitudes_por_agente: { min: 25, max: 40 },
    tiempo_ocioso_promedio: { min: 1, max: 3 }
  },

  // Configuración de alertas
  alertas: {
    criticas: { min: 8, max: 15 },
    advertencias: { min: 15, max: 25 },
    informativas: { min: 30, max: 50 }
  },

  // Configuración de escalamientos
  escalamientos: {
    total: { min: 50, max: 80 },
    por_prioridad: { min: 25, max: 40 },
    por_tiempo: { min: 20, max: 30 },
    por_complejidad: { min: 15, max: 25 }
  }
}

// Función helper para generar números aleatorios dentro de un rango
export const generateRandomInRange = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

// Función helper para generar números decimales aleatorios
export const generateRandomDecimal = (min, max, decimals = 1) => {
  const random = Math.random() * (max - min) + min
  return Number(random.toFixed(decimals))
}

// Función helper para generar porcentajes que sumen 100%
export const generatePercentageDistribution = (items) => {
  const total = items.reduce((sum, item) => sum + item.porcentaje, 0)
  return items.map(item => ({
    ...item,
    porcentaje: Math.round((item.porcentaje / total) * 100)
  }))
}
